import React from "react";
import { useTranslation } from "react-i18next";
import PublicPage from "../../public/PublicPage";
import SupportPage from "../../public/pages/SupportPage";

const Support = () => {
  const { t } = useTranslation();
  return (
    <PublicPage>
      <SupportPage t={t} />
    </PublicPage>
  );
};

export default Support;
